export default __webpack_public_path__ + "static/media/hangout.1b72a9bd.PNG";